import React, { useEffect, useId, useRef, useState } from 'react';
import { inputClass } from './PageHeader';

const SearchableSelect = ({
  label,
  value,
  onChange,
  options = [],
  placeholder = 'Search or select…',
  disabled = false,
  required = false,
  className = '',
  allowEmpty = false,
  emptyLabel = '—',
}) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const containerRef = useRef(null);
  const inputId = useId();

  const selected = options.find((o) => String(o.value) === String(value));
  const filtered = options.filter((o) =>
    o.label.toLowerCase().includes(query.toLowerCase())
  );

  useEffect(() => {
    const handleClick = (e) => {
      if (!containerRef.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useEffect(() => {
    if (!open) setQuery('');
  }, [open]);

  const displayValue = open ? query : selected?.label || '';

  const pick = (optionValue) => {
    onChange(optionValue);
    setOpen(false);
    setQuery('');
  };

  return (
    <div className={className} ref={containerRef}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium mb-1">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={inputId}
          type="text"
          className={inputClass}
          value={displayValue}
          onChange={(e) => {
            setQuery(e.target.value);
            setOpen(true);
          }}
          onFocus={() => setOpen(true)}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete="off"
        />
        {required && (
          <input
            tabIndex={-1}
            className="sr-only"
            value={value}
            onChange={() => {}}
            required
          />
        )}
        {open && !disabled && (
          <ul className="absolute z-20 mt-1 w-full max-h-48 overflow-auto bg-white border border-slate-200 rounded-lg shadow-lg text-sm">
            {allowEmpty && (
              <li>
                <button
                  type="button"
                  className="w-full text-left px-3 py-2 hover:bg-teal-50 text-slate-500"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => pick('')}
                >
                  {emptyLabel}
                </button>
              </li>
            )}
            {filtered.length === 0 ? (
              <li className="px-3 py-2 text-slate-400">No matches</li>
            ) : (
              filtered.map((o) => (
                <li key={o.value}>
                  <button
                    type="button"
                    className={`w-full text-left px-3 py-2 hover:bg-teal-50 ${
                      String(o.value) === String(value) ? 'bg-teal-50 font-medium' : ''
                    }`}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => pick(o.value)}
                  >
                    {o.label}
                  </button>
                </li>
              ))
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SearchableSelect;
